import React from "react";
import PropTypes from "prop-types";

import {
  Root,
  Content,
  ImageContainer,
  TextContainer,
  Title,
  Desc,
  Cta,
  List,
} from "./TwoColumnSection.style";

export const TwoColumnSection = ({
  imageSrc = "",
  title = "",
  desc = "",
  ctaText = "",
  ctaUrl = "",
  ctaTarget = "_self",
  bgColor = "#fff",
  accentColor = "#533fa4",
  reverse = false,
}) => {
  return (
    <Root $accentColor={accentColor} style={{ backgroundColor: bgColor }}>
      <Content className={reverse && "--reverse"}>
        <ImageContainer>
          <img src={imageSrc} alt={title} />
        </ImageContainer>
        <TextContainer>
          <Title>{title}</Title>
          <Desc>{desc}</Desc>
          {ctaText && ctaUrl && (
            <Cta
              to={ctaUrl}
              style={{ backgroundColor: accentColor }}
              target={ctaTarget}
            >
              <span>{ctaText}</span>
              <svg
                xmlns="http://www.w3.org/2000/svg"
                viewBox="0 0 16 16"
                width={16}
                height={16}
              >
                <path
                  d="m5.683 14.354-1.055-1.058 5.111-5.1v-.389l-5.111-5.1L5.684 1.65l5.55 5.541v1.626Z"
                  fill="currentColor"
                />
              </svg>
            </Cta>
          )}
        </TextContainer>
      </Content>
    </Root>
  );
};

TwoColumnSection.List = List;

TwoColumnSection.propTypes = {
  imageSrc: PropTypes.string.isRequired,
  title: PropTypes.oneOfType([PropTypes.string, PropTypes.node]).isRequired,
  desc: PropTypes.oneOfType([PropTypes.string, PropTypes.node]).isRequired,
};
